export default __webpack_public_path__ + "static/media/g3.0ea6df93.jpg";